import {
  DefaultNavigatorConfiguration,
  PreQualifiedCustomerNavigatorConfiguration
} from "../App/Compositions/NavigatorConfigurations";
import {
  screeningStepConfigurations,
  staticCenterBookingStepConfigurations
} from "../App/Compositions/StepConfigurations";
import { Flow } from "./IFlow";

const rebookFlowName = "rebook";

/** The flow that the user should experience when rebooking a cancelled or no-showed appointment. */
class RebookFlow extends Flow {
  static readonly flowName = rebookFlowName;

  constructor(isCustomerPreQualified: boolean) {
    isCustomerPreQualified
      ? super(rebookFlowName, { ...staticCenterBookingStepConfigurations }, [
          ...PreQualifiedCustomerNavigatorConfiguration
        ])
      : super(rebookFlowName, { ...screeningStepConfigurations, ...staticCenterBookingStepConfigurations }, [
          ...DefaultNavigatorConfiguration
        ]);
  }
}

export default RebookFlow;
